import Layout from '@/layout';
var orderViewConfigRouter = {
  path: '/orderViewConfig',
  component: Layout,
  redirect: '/orderViewConfig/config',
  name: 'OrderViewConfig',
  meta: {
    title: '订单查看配置',
    icon: 'clipboard'
  },
  children: [{
    path: 'config',
    name: 'OrderViewConfigIndex',
    component: function component() {
      return import('@/views/orderViewConfig/index');
    },
    meta: {
      title: '订单查看配置',
      icon: ''
    }
  }]
};
export default orderViewConfigRouter;